module.exports = __webpack_public_path__ + "static/media/fgrs.27b91f89.svg";